"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useCallback, useRef } from "react";
import Image, { type StaticImageData } from "next/image";
import { useTranslation } from "react-i18next";
import useEmblaCarousel from "embla-carousel-react";
import QuoteIcon from "@/components/Icons/QuoteIcon";
import { createSalaryHeroCarouselPointerHandlers } from "@/components/SalaryPage/SalaryHeroCarousel/salaryHeroCarouselPointerHandlers";
import styles from "./testimonialsSection.module.scss";
const AUTO_ADVANCE_MS = 6_000;
export type TestimonialSlide = {
  id: number;
  quote: string;
  name: string;
  role: string;
  image: StaticImageData;
};
export type TestimonialsSectionProps = {
  testimonials: TestimonialSlide[];
};
export default function TestimonialsSection(t0) {
  const $ = _c(37);
  const {
    testimonials
  } = t0;
  const {
    t
  } = useTranslation();
  const slideCount = testimonials.length;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      loop: true,
      align: "center",
      slidesToScroll: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [autoplayStopped, setAutoplayStopped] = useState(false);
  const pointerStartX = useRef(null);
  let t2;
  if ($[1] !== emblaApi) {
    t2 = index => {
      emblaApi?.goTo(index);
    };
    $[1] = emblaApi;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const scrollTo = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setAutoplayStopped(true);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const stopAutoplay = t3;
  let t4;
  let t5;
  if ($[4] !== autoplayStopped || $[5] !== emblaApi) {
    t4 = () => {
      if (!emblaApi || autoplayStopped) {
        return;
      }
      const advance = () => {
        emblaApi.goToNext();
      };
      const intervalId = setInterval(advance, AUTO_ADVANCE_MS);
      return () => clearInterval(intervalId);
    };
    t5 = [emblaApi, autoplayStopped];
    $[4] = autoplayStopped;
    $[5] = emblaApi;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[8] !== emblaApi) {
    t6 = () => {
      if (!emblaApi) {
        return;
      }
      setSelectedIndex(emblaApi.selectedSnap());
      const handleSelect = () => setSelectedIndex(emblaApi.selectedSnap());
      emblaApi.on("select", handleSelect);
      const {
        handlePointerDown,
        handlePointerMove,
        handlePointerUp
      } = createSalaryHeroCarouselPointerHandlers({
        pointerStartX,
        onDragExceeded: stopAutoplay
      });
      emblaApi.on("pointerdown", handlePointerDown);
      emblaApi.on("pointermove", handlePointerMove);
      emblaApi.on("pointerup", handlePointerUp);
      return () => {
        emblaApi.off("select", handleSelect);
        emblaApi.off("pointerdown", handlePointerDown);
        emblaApi.off("pointermove", handlePointerMove);
        emblaApi.off("pointerup", handlePointerUp);
      };
    };
    t7 = [emblaApi, stopAutoplay];
    $[8] = emblaApi;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let t8;
  if ($[11] !== t || $[12] !== testimonials) {
    let t9;
    if ($[14] !== t) {
      t9 = testimonial => <div key={testimonial.id} className={styles.testimonialsEmblaSlide}><div className={styles.testimonialCard}><QuoteIcon className={styles.quoteIcon} /><p className={styles.testimonialQuote}>{t(testimonial.quote)}</p><div className={styles.testimonialAuthor}><div className={styles.testimonialAvatar}><Image src={testimonial.image} alt={testimonial.name} unoptimized={true} width={40} height={40} className="h-full w-full object-cover" /></div><div><p className={styles.testimonialName}>{testimonial.name}</p><p className={styles.testimonialRole}>{t(testimonial.role)}</p></div></div></div></div>;
      $[14] = t;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    t8 = testimonials.map(t9);
    $[11] = t;
    $[12] = testimonials;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <div className={styles.testimonialsEmblaContainer}>{t8}</div>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== emblaRef || $[19] !== t9) {
    t10 = <div className={styles.testimonialsEmbla} ref={emblaRef}>{t9}</div>;
    $[18] = emblaRef;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== autoplayStopped || $[22] !== scrollTo || $[23] !== selectedIndex || $[24] !== slideCount || $[25] !== testimonials) {
    let t12;
    if ($[27] !== autoplayStopped || $[28] !== scrollTo || $[29] !== selectedIndex || $[30] !== slideCount) {
      t12 = (_, index_0) => {
        const isActive = selectedIndex % slideCount === index_0;
        const showProgress = isActive && !autoplayStopped;
        return <button key={index_0} type="button" className={`${styles.testimonialDot} ${showProgress ? styles.testimonialDotActiveProgress : isActive ? styles.testimonialDotActive : ""}`} style={showProgress ? {
          "--autoplay-duration": `${AUTO_ADVANCE_MS}ms`
        } as React.CSSProperties : undefined} onClick={() => scrollTo(index_0)} aria-label={`Go to testimonial ${index_0 + 1}`}>{showProgress && <span key={selectedIndex} className={styles.testimonialDotFill} aria-hidden={true} />}</button>;
      };
      $[27] = autoplayStopped;
      $[28] = scrollTo;
      $[29] = selectedIndex;
      $[30] = slideCount;
      $[31] = t12;
    } else {
      t12 = $[31];
    }
    t11 = testimonials.map(t12);
    $[21] = autoplayStopped;
    $[22] = scrollTo;
    $[23] = selectedIndex;
    $[24] = slideCount;
    $[25] = testimonials;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[32] !== t11) {
    t12 = <div className={styles.testimonialsDots}>{t11}</div>;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t12) {
    t13 = <section className={`${styles.section} ${styles.testimonialsSection}`}><div className={styles.testimonialsCarouselWrapper} onClick={stopAutoplay}>{t10}{t12}</div></section>;
    $[34] = t10;
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
}